import React from "react";

// plugin imports
import { Link, Trans } from "@herob191/gatsby-plugin-react-i18next";

// style imports
import "./footerRestaurant.scss";

// component imports
import Separator from "../../spacers/separatorH";

// util imports
import {
	getRestaurantCartaURL,
	getRestaurantReservaURL,
	getRestaurantURL,
} from "../../../utils/restaurant";
import useDayOfWeek, {
	formatHours,
	getHoursForRestaurantDate,
} from "../../../utils/date";
import useTranslate from "../../../utils/useTranslate";

// svg imports
import IconStatus from "../../../svg/icon/iconStatus.svg";
import IconMarker from "../../../svg/icon/iconMarker.svg";

// component
export default function FooterRestaurant({ restaurant }) {
	const [currentDay, setCurrentDay] = React.useState(new Date());

	React.useEffect(() => {
		const interval = setInterval(setCurrentDay(new Date()), 5 * 60 * 1000); // update every 5 minutes
		return () => clearInterval(interval);
	}, []);

	const ctaLinks = [
		{
			link: getRestaurantCartaURL(restaurant.fields.id),
			text: <Trans>Ver carta</Trans>,
		},
		{
			link: getRestaurantReservaURL(restaurant.fields.id),
			text: <Trans>Reservar</Trans>,
		},
	];

	return (
		<div>
			<Separator />
			<div className="footerRestaurant padding">
				<Link
					to={getRestaurantURL(restaurant.fields.id)}
					className="underlineHover"
				>
					<span className="h2">
						{useTranslate(restaurant.frontmatter.title)}
					</span>
				</Link>
				<div>
					<div className="contents">
						<div className="iconText">
							<IconStatus />
							<p>
								{useDayOfWeek(currentDay)}{" "}
								{formatHours(getHoursForRestaurantDate(restaurant, currentDay))}
							</p>
						</div>
						<a
							href={restaurant.frontmatter.gMapsLink}
							target="_blank"
							rel="noopener noreferrer"
							className="iconText"
						>
							<IconMarker />
							<p className="underlineHover">{restaurant.frontmatter.address}</p>
						</a>
					</div>
					<div className="ctas">
						{ctaLinks.map((cta, i) => (
							<div key={"cta" + i}>
								<div className="tiltContainer borderThick invertOnHover">
									<Link to={cta.link}>
										<span className="h3">{cta.text}</span>
									</Link>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
